import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

export const loginViaOTPApi = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunctionUnAuth(data, apiConstants.AUTH.LOGIN_VIA_OTP)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}